import { useState } from "react";
import { Sidebar } from "../SideBar";
import Dashboard from "../ui/Dashboard";

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-background/50">

      <Sidebar open={open} setOpen={setOpen} />

      <div className="flex-1 flex flex-col overflow-hidden bg-white">

        <Dashboard setOpen={setOpen} />

        <main className="flex-1 overflow-y-auto pt-[52px] xs:pt-[56px] rs:pt-[72px]">
          {children}
        </main>
      </div>
    </div>
  );
}
